import { render, staticRenderFns } from "./LunchReport.vue?vue&type=template&id=6c0a8d8e&scoped=true&"
import script from "./LunchReport.vue?vue&type=script&lang=js&"
export * from "./LunchReport.vue?vue&type=script&lang=js&"
import style0 from "./LunchReport.vue?vue&type=style&index=0&id=6c0a8d8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0a8d8e",
  null
  
)

/* custom blocks */
import block0 from "./LunchReport.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports